module.exports = __webpack_public_path__ + "img/et.1d986679.svg";